import './instrumentation'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import AppThemeProvider from './styling/AppThemeProvider'
import { fetchLoginTheme } from './common/dynamicCustomizationService'

// /// render in finally, to make sure customizations are loaded
// /// on the other hand, if things go really bad for loading
// /// customization, at least the default will be there

fetchLoginTheme().finally(() => {
  createRoot(document.getElementById('root')).render(
    <AppThemeProvider>
      <App />
    </AppThemeProvider>
  )
})
